import { render, staticRenderFns } from "./PostMedia.vue?vue&type=template&id=6f749fe1&"
import script from "./PostMedia.vue?vue&type=script&lang=js&"
export * from "./PostMedia.vue?vue&type=script&lang=js&"
import style0 from "./PostMedia.vue?vue&type=style&index=0&id=6f749fe1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports